import { useState } from "react";
import { Check, Link2, Linkedin } from "lucide-react";

export const ShareCertificate = ({ code }) => {
  const [copied, setCopied] = useState(false);
  const origin = window.location.origin;
  const shareUrl = `${origin}/api/certificates/${encodeURIComponent(code)}/share`;
  const copy = async () => { await navigator.clipboard.writeText(`${origin}/verify/${code}`); setCopied(true); setTimeout(() => setCopied(false), 1800); };
  return <div className="share-row" data-testid="certificate-share">
    <a className="share-btn linkedin" href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" data-testid="certificate-linkedin-share"><Linkedin size={14}/> Share on LinkedIn</a>
    <button type="button" className="share-btn" onClick={copy} data-testid="certificate-copy-link">{copied ? <><Check size={14}/> Copied</> : <><Link2 size={14}/> Copy verify link</>}</button>
  </div>;
};
